import React from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import AuthForm from "../components/AuthForm";
import SenAiLanding from "./SenAiLanding";

const Login = () => {
  const [searchParams] = useSearchParams();
  const [user, loading] = useAuthState(auth);
  
  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // If user is authenticated, redirect to dashboard (handled by AuthForm)
  if (user) {
    return <AuthForm />;
  }

  // Check if user wants to see auth form (login/signup)
  const authMode = searchParams.get('mode');
  
  if (authMode === 'auth' || authMode === 'signup') {
    return <AuthForm />;
  }

  // Default: show landing page for non-authenticated users
  return <SenAiLanding />;
};

export default Login;





